import { patchRequest, postRequest } from '../utils'

/** Bulk-write CS onto beams/columns/purlins/rips/lintels (sets UserDefined for policy elements). */
export const saveCrossSectionsOnElement: RequestTypeVariable = {
  getKey: (id: string) => ['saveCrossSectionsOnElement', id],
  request: async (projectId: string, data: CrossSectionOnElement[]): Promise<void> => {
    await postRequest<CrossSectionOnElement[]>({
      url: `/projects/${projectId}/planar-model/cross-sections/set-multiple`,
      data,
    })
  },
}

/** Single-element CS update via set-multiple. */
export const updateElementCrossSectionAssignment: RequestTypeVariable = {
  getKey: (id: string) => ['updateElementCrossSectionAssignment', id],
  request: async (projectId: string, data: ElementCSAssignment): Promise<void> => {
    const dataForRequest: CrossSectionOnElement = {
      ...data.element_cs,
      element_guid: data.element_guid,
    }

    await postRequest<CrossSectionOnElement[]>({
      url: `/projects/${projectId}/planar-model/cross-sections/set-multiple`,
      data: [dataForRequest],
    })
  },
}

/**
 * Set crossSectionPolicy on rips/lintels (and optionally other policy elements).
 * Assumed backend endpoint — may still be missing; see FE summary.
 */
export const updateElementCrossSectionPolicy: RequestTypeVariable = {
  getKey: (id: string) => ['updateElementCrossSectionPolicy', id],
  request: async (projectId: string, data: ElementCrossSectionPolicyUpdate): Promise<void> => {
    await patchRequest<ElementCrossSectionPolicyUpdate>({
      url: `/projects/${projectId}/planar-model/cross-sections/policy`,
      data,
    })
  },
}
